import { LovewallSubscriptionPlan } from "../../types/subscription";
import { generateAPI } from "../api.generator";

export const getLovewallSubscriptionPlans = generateAPI<
  {},
  LovewallSubscriptionPlan[]
>("get", "subscriptions/plan/lovewall/all");
